
// src/components/Message/UserMessage.js
import React from 'react';
import './Message.css';
import userIcon from '../../logos_images/user_icon_teal2.png'; // Import the user icon image

function UserMessage({ text, direction }) {
    return (
        <div className="message-row user-message" style={{ marginBottom: '20px' }}>
            <div className="message-bubble user-bubble" dir={direction} tabIndex={0}>
                {text.split('\n').map((line, index) => (
                    <p key={index}>{line}</p>
                ))}
            </div>
            <div className="icon-container">
                {/* Replace the FaUser icon with the imported userIcon image */}
                <img src={userIcon} alt="" role="presentation" aria-hidden="true" className="message-icon" />
            </div>
        </div>
    );
}

export default UserMessage;
